import React from "react";
import Styles from "./Styles.module.css";
import Slider8 from "./programsliders/Slider8";
import SkeletonDisplay from "../hooks/skeletonDisplay";

function InstitutionalCapacityStrengthening() {
  return (
    <div>
      <div className={Styles.slider1}>
        <div className={Styles.mainContainer}>
          <SkeletonDisplay>
            <img src="/aboutus/aboutus.png" alt="Curd Africa" />
          </SkeletonDisplay>
          <button>
            Institutional Capacity Strengthening, Fundraising and Partnership
          </button>
        </div>
      </div>
      <div style={{ margin: "0 auto" }}>
        <Slider8 />
      </div>
    </div>
  );
}

export default InstitutionalCapacityStrengthening;
